import { render, staticRenderFns } from "./cateTips.vue?vue&type=template&id=51575988&scoped=true&"
import script from "./cateTips.vue?vue&type=script&lang=js&"
export * from "./cateTips.vue?vue&type=script&lang=js&"
import style0 from "./cateTips.vue?vue&type=style&index=0&id=51575988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51575988",
  null
  
)

export default component.exports